var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondovista"},[_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"slide-fade","appear":""}},[_c('b-card',[_c('h2',[_c('b-icon-building'),_vm._v(" Gestión de Colegios")],1),_c('b-card-text',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"line-numbers":true,"search-options":{
              enabled: true,
              placeholder: 'Buscar...'
            },"pagination-options":{
              enabled: true,
              mode: 'records',
              nextLabel: 'Siguiente',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Filas por página',
              ofLabel: 'de',
              pageLabel: 'página', // for 'pages' mode
              allLabel: 'Todo'
            },"styleClass":"vgt-table bordered condensed striped sm","rows":_vm.rows},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'nombre')?_c('span',[_c('a',[_vm._v(_vm._s(props.row.nombre.toLowerCase()))])]):_vm._e()]}}])},[_c('div',{attrs:{"slot":"table-actions"},slot:"table-actions"},[_c('b-button',{staticClass:"mr-2 ml-5",attrs:{"size":"sm"}},[_vm._v("Crear Colegio")])],1)])],1)],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }